<template>
    <site-img
        class="md-team carousel-fashion"
        v-if="allTotal > 0"
        type="bgImg"
        :src="bgType === 'img' ? useBgSrc : ''"
        :style="{
            backgroundColor: bgType === 'color' ? bgColor : '',
            paddingTop,
            marginBottom
        }"
    >
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileNoMargin="mobileNoMargin"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
            :noMargin="true"
            :noPadding="true"
        >
            <div class="mg-title" v-if="fmtTitle" v-html="formatFontSize(fmtTitle, '--mg-title-size')"></div>
            <!-- SEARCH BAR START -->
            <template v-if="showSearchBar">
                <search-bar @search="searchAgents"></search-bar>
            </template>
            <Empty v-if="agents.length === 0" />

            <!-- SEARCH BAR END -->
            <div
                ref="agentsContainer"
                class="agents-container"
            >
                <swiper
                    ref="slider"
                    v-if="
                        agents.length > useSlidesPerView && sliderShow
                    "
                    class="slider-container"
                    v-bind="options"
                >
                    <slide
                        v-for="agent in agents"
                        :key="agent.id"
                        class="agent-item"
                        :class="{ mobile: isMobileSize }"
                    >
                        <agent-item
                            :agent="agent"
                            :licenseName="licenseName"
                            :detailUrlTarget="detailUrlTarget"
                        >
                        </agent-item>
                    </slide>
                </swiper>
                <div
                    v-if="agents.length <= useSlidesPerView"
                    class="agent-list no-swiper"
                >
                    <div
                        v-for="(agent, index) in agents"
                        :key="agent.id"
                        class="agent-item"
                        :class="{ mobile: isMobileSize }"
                        :style="{
                            width: `calc(100% / ${useSlidesPerView} - ${
                                ((useSlidesPerView - 1) * useAgentItemSpace) /
                                useSlidesPerView
                            }px)`,
                            marginRight:
                                index < agents.length - 1
                                    ? useAgentItemSpace + 'px'
                                    : '0'
                        }"
                    >
                        <agent-item
                            :agent="agent"
                            :licenseName="licenseName"
                            :detailUrlTarget="detailUrlTarget"
                        >
                        </agent-item>
                    </div>
                </div>
                <i
                    v-if="agents.length > useSlidesPerView"
                    class="iconfont icon-prev prev-el"
                ></i>
                <i
                    v-if="agents.length > useSlidesPerView"
                    class="iconfont icon-next next-el"
                ></i>
            </div>
        </module-box>
    </site-img>
</template>

<script>
import common from '../index';
import carousel from '../carousel';
import agentItem from './agent-item.vue';
import { normal } from '../../defaultSpacing';
import search from '../search';
export default {
    mixins: [common, carousel, search],
    data: function() {
        return {
            ...normal,
            slidesPerView: 6,
            mobileSlidesPerView: 3
        };
    },
    computed: {
        marginBottom() {
            return (
                (this.isMobileSize ? this.mobileBtmSpacing : this.btmSpacing) + 'px'
            );
        },
        selIndex() {
            return this.selectIndex > 0 ? this.selectIndex : 0;
        }
    },
    components: {
        agentItem
    }
};
</script>

<style lang="scss">
@import './carousel.scss';
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.md-team.carousel-fashion {
    @include carousel-common();
    .com-search-bar {
        padding: 20px;
        background-color: #f5f6fa;
        margin-bottom: 30px;
        @include media-600 {
            margin: 0 5px 30px 5px;
            .search-button {
                margin-top: 25px;
            }
        }

        button {
            font-size: 14px;
            text-transform: uppercase;
        }
        input {
            border: none;
            @include adapter((padding-left, 15px, 10px));
        }
        ::-webkit-input-placeholder {
            color: #8b93a7;
        }
    }
    .mg-container {
        overflow: visible;
    }
}
</style>
